import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { COLORS } from '../../lib/constants'
import actions from './actions'
import Eyecon from '../Form/Eyecon'
import Group from '../../assets/svg/Remix/Group'
import Pushpin from '../../assets/svg/Remix/Pushpin'
import CachedSvg from '../CachedSvg'
import styles from './CollectionListItem.module.scss'

function CollectionListItem(props) {
	const toggleCollectionVisibility = (visibility) => {
		if (props.featureIds.length) {
			props.toggleCollectionVisibility(props.collection.uuid, visibility)
		}
	}

	return (
		<li id={props.collection.uuid} className={styles.collectionItem}>
			<div onClick={props.onClick} style={{ display: 'flex', width: '100%' }}>
				<div className={styles.collectionDetails}>
					<div className={styles.collectionTitle}>{props.collection.title}</div>
					<div className={styles.featureTotal}>
						{props.active ? (
							<>
								<span className={styles.activeText}>
									<CachedSvg component={Pushpin} componentName="Pushpin" svgProps={{ color: COLORS.ghOrange, width: 12, height: 12 }} width={12} height={12} alt="Active" />
									Active
								</span>
								<span className={styles.separator}>•</span>
							</>
						) : null}
						{props.featureIds.length} items
					</div>
				</div>
			</div>
			<div className={styles.collectionVisibility}>
				{!props.collection.isOwner ? <CachedSvg component={Group} componentName="Group" svgProps={{ color: COLORS.ghGreyLtText, width: 24, height: 24 }} width={24} height={24} alt="Group" /> : null}
				<Eyecon isOn={props.hasVisibleFeatures} onChange={(visibility) => toggleCollectionVisibility(visibility)} />
			</div>
		</li>
	)
}

CollectionListItem.propTypes = {
	active: PropTypes.bool,
	collection: PropTypes.object,
	featureIds: PropTypes.array,
	hasVisibleFeatures: PropTypes.bool,
	onClick: PropTypes.func,
	// actions
	toggleCollectionVisibility: PropTypes.func,
}

CollectionListItem.defaultProps = {
	onClick: PropTypes.func,
	active: false,
}

export default connect((model, currentProps) => {
	const {	featuresList,	preferences } = model.features
	// const { collection } = currentProps
	const { featureIds } = currentProps.collection
	let hasVisibleFeatures = false

	if (featureIds.length) {
		if (!preferences.visible.features.length) {
      hasVisibleFeatures = preferences.visible.all
    } else {
			let featureIndex = null
      for (let fidi = 0; fidi < featureIds.length; fidi++) {
        featureIndex = featuresList.findIndex((fl) => fl.uuid === featureIds[fidi])
        if (featureIndex > -1) {
          hasVisibleFeatures = preferences.visible.features.includes(featuresList[featureIndex].id)
          if (hasVisibleFeatures) break
        }
      }
    }
	}

	return {
		// collection,
		featureIds,
		hasVisibleFeatures,
	}
}, actions)(CollectionListItem)
